export const RESOURCES = {
  user: 'user',
  role: 'role',
  group: 'group',
  application: 'application',
  client: 'client',
  sow: 'sow',
  project: 'project',
  allocation: 'allocation',
  resourceRole: 'resource-role',
  document: 'document',
  milestone: 'milestone',
  task: 'task',
  candidate: 'candidate',
  candidateSensitive: 'candidate-sensitive',
  candidateDocument: 'candidate-document',
  formTemplate: 'form-template',
  emailTemplate: 'email-template',
  employee: 'employee',
  workflow: 'workflow',
  directory: 'directory',
  directNda: 'direct-nda',
  directNdaSettings: 'direct-nda-settings',
  questionnaire: 'questionnaire',
  trainingGroup: 'training-group',
  trainingAssignment: 'training-assignment',
  trainingAttempt: 'training-attempt',
  certificate: 'certificate',
  trainingSettings: 'training-settings',
} as const;

export const ACTIONS = {
  read: 'read',
  create: 'create',
  update: 'update',
  delete: 'delete',
  /// Decide something another role submitted, and skip that queue yourself.
  approve: 'approve',
  /// Hand a record to someone else's care. Not implied by manage: it is granted by name.
  assign: 'assign',
  manage: 'manage',
} as const;

export type Resource = (typeof RESOURCES)[keyof typeof RESOURCES];
export type Action = (typeof ACTIONS)[keyof typeof ACTIONS];
export type Permission = `${Resource}:${Action}`;

export const permission = (resource: Resource, action: Action): Permission =>
  `${resource}:${action}`;
